import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import DateFns from "date-fns";
import { addApplyJobs } from "../../redux/action/jobs/apply_jobsAction";
import { getProfileInfo } from "../../redux/action/profileInfoAction";
import { BsFillShareFill } from "react-icons/bs";
import ReferCandidate from "./referCandidate";
import CommonFlexComponent from "../../common/commonFlexComponent";

// import {} from 'react-bootstrap'

import { Row, Col, Button } from "reactstrap";

class ParticularMatchedJob extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      error: "",
      referPopUp: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.handleViewOpenReferCandi = this.handleViewOpenReferCandi.bind(this);
    this.closeReferPopUp = this.closeReferPopUp.bind(this);
  }

  handleViewOpenReferCandi() {
    this.setState({
      referPopUp: !this.state.referPopUp,
      showApplyJobPopUp: false,
    });
  }

  closeReferPopUp() {
    this.setState({
      referPopUp: false,
    });
  }
  onSubmit(e) {
    e.preventDefault();
    // submitValidator(e.target);
    let data = {
      jobReqirementId: this.props.storeData[0].jobRequirement,
      jobId: this.props.storeData[0].id,
      canInfoId: this.props.profile.data.id,
      canUserId: this.props.profile.data.canUserId,
      candidateSource: "online",
      candidateStatus: "Applied",
    };
    this.props.addApplyJobs(data, this.props.back);
  }

  componentDidMount() {
    this.props.getProfileInfo();
  }

  render() {
    console.log(this.props.PublishJobs);

    return (
      <Row>
        <div>
          <i
            data-toggle="tooltip"
            data-placement="top"
            title="Close"
            onClick={() => this.props.back()}
            className="material-icons pointer cancel-button"
          >
            cancel
          </i>
        </div>

        {!this.state.edit ? (
          <Col md="12">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <h3
                data-toggle="tooltip"
                data-placement="top"
                title="Refer Candidate"
                onClick={this.handleViewOpenReferCandi}
                style={{ color: "#04044c", marginRight: "1.5rem" }}
              >
                {" "}
                <BsFillShareFill size="25" />{" "}
              </h3>
            </div>

            <h5
              style={{ fontSize: "1.25rem", fontWeight: "500" }}
              className="bold center mb-4"
            >
              {" "}
              Job Id :
              {this.props.storeData.length > 0 && this.props.storeData[0].id}
            </h5>
            {this.state.referPopUp && (
              <ReferCandidate
                reqId={this.props.storeData[0].jobRequirement}
                // jobId={this.props.storeData.length >0 && this.props.storeData[0].id}
                showPopUp={this.state.referPopUp}
                handleCloseModal={this.closeReferPopUp}
              />
            )}

            {this.props.storeData.length > 0 &&
              this.props.storeData.map((data) => {
                return (
                  <div>
                    {/* <Row>
                    <Col md="4">
                      <ul className="CustDetails-ul">
                    
                        <li class="col-sm-12" style={{ marginTop: "1rem" }}>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              width: "40%",
                            }}
                            className="label-sm bold"
                          >
                            Req. Type
                          </span>
                          <span className="label-sm">
                            &nbsp;&nbsp;:&nbsp;&nbsp;{data.jobType}
                          </span>
                        </li>
                        <li class="col-sm-12" style={{ marginTop: "1rem" }}>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              width: "40%",
                            }}
                            className="label-sm bold customer-span-label-col-1"
                          >
                            Job Category
                          </span>
                          <span className=" label-sm">
                            &nbsp;&nbsp;:&nbsp;&nbsp;{data.jobCategory}
                          </span>
                        </li>
                        <li style={{ marginTop: "1rem" }}>
                          <span
                            style={{
                           
                              fontSize: "14px",
                              fontWeight: "bold",
                              width: "40%",
                            }}
                            className="label-sm bold customer-span-label-col-1"
                          >
                            Job Position
                          </span>
                          <span className="label-sm">
                            &nbsp;&nbsp;:&nbsp;&nbsp;{data.jobPosition}
                          </span>
                        </li>
                        <li style={{ marginTop: "1rem" }}>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              width: "40%",
                            }}
                            className="label-sm bold customer-span-label-col-1"
                          >
                            Qualification
                          </span>
                          <span className=" label-sm">
                            &nbsp;&nbsp;:&nbsp;&nbsp;{data.qualifications}
                          </span>
                        </li>
                        <li style={{ marginTop: "1rem" }}>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              width: "40%",
                            }}
                            className="label-sm bold customer-span-label-col-1"
                          >
                            Job Description
                          </span>
                          <span className=" label-sm">
                            &nbsp;&nbsp;:&nbsp;&nbsp;{data.jobDescription}
                          </span>
                        </li>
                      

                        <li style={{ marginTop: "1rem" }}>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              width: "40%",
                            }}
                            className="label-sm bold customer-span-label-col-1"
                          >
                            Start Date
                          </span>
                          <span className=" label-sm">
                            &nbsp;&nbsp;:&nbsp;&nbsp;
                            {data.startDate
                              ? DateFns.format(data.startDate, "DD-MM-YYYY")
                              : ""}
                          </span>
                        </li>

                        <li style={{ marginTop: "1rem" }}>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              width: "40%",
                            }}
                            className="label-sm bold customer-span-label-col-1"
                          >
                            End Date
                          </span>
                          <span className=" label-sm">
                            &nbsp;&nbsp;:&nbsp;&nbsp;
                            {data.endDate
                              ? DateFns.format(data.endDate, "DD-MM-YYYY")
                              : ""}
                          </span>
                        </li>
                      
                      </ul>
                    </Col>
                   
                    <Col style={{ marginLeft: "10rem" }} md="4">
                      <ul className="CustDetails-ul">
                      <li style={{ marginTop: "1rem" }}>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              width: "40%",
                            }}
                            className="label-sm bold customer-span-label-col-1"
                          >
                            Job Location
                          </span>
                          <span className=" label-sm">
                            &nbsp;&nbsp;:&nbsp;&nbsp;{data.jobLocation}
                          </span>
                        </li>
                       
                        <li style={{ marginTop: "1rem" }}>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              width: "40%",
                            }}
                            className="label-sm bold customer-span-label-col-1"
                          >
                            Primary Skills
                          </span>
                          <span className=" label-sm">
                            &nbsp;&nbsp;:&nbsp;&nbsp;{data.primarySkills}
                          </span>
                        </li>
                        <li style={{ marginTop: "1rem" }}>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              width: "40%",
                            }}
                            className="label-sm bold customer-span-label-col-1"
                          >
                            Secondary Skills
                          </span>
                          <span className=" label-sm">
                            &nbsp;&nbsp;:&nbsp;&nbsp;{data.secondarySkills}
                          </span>
                        </li>
                      

                      
                        <li style={{ marginTop: "1rem" }}>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              width: "40%",
                            }}
                            className=" bold label-sm customer-span-label-col-1"
                          >
                            Job Timing
                          </span>
                          <span className=" label-sm">
                            &nbsp;&nbsp;:&nbsp;&nbsp;{data.jobTimings}
                          </span>
                        </li>

                     
                        
                        <li style={{ marginTop: "1rem" }}>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              width: "40%",
                            }}
                            className="label-sm bold customer-span-label-col-1"
                          >
                            Min Yrs of Exp.
                          </span>
                          <span className=" label-sm">
                            &nbsp;&nbsp;:&nbsp;&nbsp;{data.minYearsOfExp}
                          </span>
                        </li>
                        <li style={{ marginTop: "1rem" }}>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              width: "40%",
                            }}
                            className="label-sm bold customer-span-label-col-1"
                          >
                            Max Yrs of Exp.
                          </span>
                          <span className=" label-sm">
                            &nbsp;&nbsp;:&nbsp;&nbsp;{data.maxYearsOfExp}
                          </span>
                        </li>
                      
                       
                      </ul>
                    </Col>
                  </Row> */}

                    <Row>
                      <Col>
                        <ul>
                          <li>
                            <CommonFlexComponent
                              label="Req. Type"
                              data={data.jobType}
                            />
                          </li>
                          <li>
                            <CommonFlexComponent
                              label="Job Category"
                              data={data.jobCategory}
                            />
                          </li>
                          <li>
                            <CommonFlexComponent
                              label="Job jobPosition"
                              data={data.jobPosition}
                            />
                          </li>
                          <li>
                            <CommonFlexComponent
                              label="Qualifications"
                              data={data.qualifications}
                            />
                          </li>
                          <li>
                            <CommonFlexComponent
                              label="Qualifications"
                              data={data.qualifications}
                            />
                          </li>
                          <li>
                            <CommonFlexComponent
                              label="Job Description"
                              data={data.jobDescription}
                            />
                          </li>
                          <li>
                            <CommonFlexComponent
                              label="Start Date"
                              data= {data.startDate
                                ? DateFns.format(data.startDate, "DD-MM-YYYY")
                                : ""}
                            />
                          </li>
                          <li>
                            <CommonFlexComponent
                              label="End Date"
                              data= {data.endDate
                                ? DateFns.format(data.endDate, "DD-MM-YYYY")
                                : ""}
                            />
                          </li>
                        </ul>
                      </Col>

                      <Col>
                      <ul>
                        <li >
                        <CommonFlexComponent
                              label="Job Location"
                              data= {data.jobLocation}
                            />
                        </li>
                        <li>
                        <CommonFlexComponent
                              label="Primary Skills"
                              data= {data.primarySkills}
                            />
                        </li>
                        <li>
                        <CommonFlexComponent
                              label="Secondary Skills"
                              data= {data.secondarySkills}
                            />
                        </li>
                        <li>
                        <CommonFlexComponent
                              label="Job Timings"
                              data= {data.jobTimings}
                            />
                        </li>
                        <li>
                        <CommonFlexComponent
                              label="Min Years of Exp."
                              data= {data.minYearsOfExp}
                            />
                        </li>
                        <li>
                        <CommonFlexComponent
                              label="Max Years of Exp."
                              data= {data.maxYearsOfExp}
                            />
                        </li>
                      </ul>
                      </Col>
                    </Row>

                    <div className="center">
                      <Button
                        onClick={this.onSubmit}
                        tabIndex="9"
                        type="submit"
                        style={{
                          background: "#0984e3",
                          marginTop: "2rem",
                          color: "white",
                        }}
                        className="btn login-button white-text"
                      >
                        Apply Jobs
                      </Button>
                    </div>
                    {/* <Divider />
                  <DetailsPageFooter
                    createdBy={data.createdBy}
                    createdOn={data.createdOn}
                    updatedBy={data.updatedBy}
                    updatedOn={data.updatedOn}
                  /> */}
                  </div>
                );
              })}
          </Col>
        ) : (
          <Row></Row>
        )}
      </Row>
    );
  }
}

ParticularMatchedJob.propTypes = {};

const mapStateToProps = (state) => ({
  PublishJobs: state.PublishJobs,
  ApplyJobs: state.ApplyJobs,
  profile: state.profile,
});

export default connect(mapStateToProps, {
  addApplyJobs,
  getProfileInfo,
})(withRouter(ParticularMatchedJob));
